export type JsonObject = Record<string, unknown>;

export function parseJsonObject(value: string | null | undefined): JsonObject {
  if (!value?.trim()) return {};
  try {
    const parsed = JSON.parse(value) as unknown;
    return isJsonObject(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function isJsonObject(value: unknown): value is JsonObject {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** `configSchema.ui.serviceGroup` of a capability, if it belongs to a user-facing service. */
export function serviceGroupOf(configSchema: string | null | undefined): string | null {
  const ui = parseJsonObject(configSchema).ui;
  return isJsonObject(ui) && typeof ui.serviceGroup === 'string' ? ui.serviceGroup : null;
}

/** "5, 8, 10" → [5, 8, 10]; null when any entry is not a positive integer. */
export function parsePositiveIntList(value: string): number[] | null {
  const items = splitList(value).map(Number);
  return items.length > 0 && items.every((item) => Number.isInteger(item) && item > 0)
    ? items
    : null;
}

export function splitList(value: string): string[] {
  return value
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export function joinList(value: unknown): string {
  return Array.isArray(value) ? value.join(', ') : '';
}

/** A capability configured as a video service (its config has video duration limits). */
export function isVideoServiceConfig(configSchema: string | null | undefined): boolean {
  const limits = parseJsonObject(configSchema).limits;
  return isJsonObject(limits) && Array.isArray(limits.durationSecondsOptions);
}
